<img [src]="show?.showImg ?? showsService.DEFAULT_IMG" slot="start" />

<ion-label>
  <p class="micro-bold">
    {{ show?.showName ?? 'Unknown Show' }}
  </p>
</ion-label>
